const ALIGN = 'center'

export default [
  {
    title: '账号名称',
    key: 'adAccountName',
    width: 140,
    fixed: true,
    overflow: true
  },
  {
    title: '账号简称',
    key: 'adAccountSimpleName',
    width: 200,
    fixed: true,
    overflow: true
  },
  {
    title: '媒体',
    key: 'mediaName',
    type: 'basic',
    overflow: true,
    width: 72
  },
  {
    title: '计划主ID',
    key: 'advertiserId',
    type: 'basic',
    align: ALIGN,
    overflow: true,
    width: 84
  },
  {
    title: '草花ID',
    key: 'adAccountId',
    width: 80,
    align: ALIGN,
    overflow: true,
    type: 'basic'
  },
  {
    title: '管理人员',
    type: 'basic',
    key: 'managerNames',
    width: 74,
    overflow: true
  },
  {
    title: '账号预算',
    type: 'basic',
    key: 'accountDayBudget',
    width: 74,
    overflow: true,
    exclude_export: true
  },
  {
    title: '实时余额',
    key: 'accountMoney',
    type: 'basic',
    align: ALIGN,
    width: 70
  },
  {
    title: '新建计划数',
    key: 'planCount',
    type: 'basic',
    sortable: 'custom',
    align: ALIGN,
    width: 72
  },
  {
    title: '无效计划率',
    key: 'invalidPlanRate',
    type: 'basic',
    sortable: 'custom',
    align: ALIGN,
    width: 72
  },
  {
    title: '无效消耗率',
    key: 'invalidPlanAmountRate',
    type: 'basic',
    sortable: 'custom',
    align: ALIGN,
    width: 72
  },
  {
    title: '在投计划数',
    key: 'validPlanCounts',
    type: 'basic',
    align: ALIGN,
    width: 72
  },
  {
    title: '累计ROI',
    key: 'sumRebate',
    type: 'basic',
    sortable: 'custom',
    align: ALIGN,
    width: 55
  },
  {
    title: '账面消耗',
    key: 'paperUseAmount',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 90
  },
  {
    title: '赠款消耗',
    key: 'giveAmount',
    type: 'report',
    align: ALIGN,
    width: 90
  },
  {
    title: '实际消耗',
    key: 'amount',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 90
  },
  {
    title: '曝光量',
    key: 'pv',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 80
  },
  {
    title: '采集点击数',
    key: 'collectClickNum',
    type: 'report',
    align: ALIGN,
    width: 72
  },
  {
    title: '点击率',
    key: 'clickRate',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 68
  },
  {
    title: '激活数',
    key: 'downNum',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 68
  },
  {
    title: '注册数',
    key: 'newUserNum',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 68
  },
  {
    title: '创角数',
    key: 'createRoleNum',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 68
  },
  {
    title: '新建角色数',
    key: 'newRoleNum',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 65
  },
  {
    title: '激活成本',
    key: 'activeCost',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 58
  },
  {
    title: '创角成本',
    key: 'createRoleCost',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 58
  },
  {
    title: '创角率',
    key: 'createRoleRate',
    type: 'report',
    align: ALIGN,
    width: 60
  },
  {
    title: '付费创角人数',
    key: 'payRoleUserNum',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 65
  },
  {
    title: '创角付费次数',
    key: 'newRolePayCnt',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 65
  },
  {
    title: '每次付费成本',
    key: 'newRolePayCntCost',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 65
  },
  {
    title: '创角付费成本',
    key: 'newPayCost',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 65
  },
  {
    title: '当日付费设备',
    key: 'payActiveDeviceNum',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 65
  },
  {
    title: '新创角付费率',
    key: 'payRoleUserRate',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 65
  },
  {
    title: '新设备付费率',
    key: 'payActiveDeviceNumRate',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 65
  },
  {
    title: '新设备充值',
    key: 'newDeviceMoney',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 65
  },
  {
    title: '新创角充值',
    key: 'newRoleMoney',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 65
  },
  {
    title: '激活总流水',
    key: 'sumMoney',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 65
  },
  {
    title: '新创角回款率',
    key: 'newRoleRate',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 65
  },
  {
    title: '新设备回款率',
    key: 'newDeviceRate',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 65
  },
  {
    title: '激活次留',
    key: 'nextDayRetainRate',
    type: 'other',
    align: ALIGN,
    width: 60
  },
  {
    title: '激活3留',
    key: 'threeDayRetainRate',
    type: 'other',
    align: ALIGN,
    width: 60
  },
  {
    title: '激活7留',
    key: 'sevenDayRetainRate',
    type: 'other',
    align: ALIGN,
    width: 60
  },
  {
    title: '激活30留',
    key: 'thirtyDayRetainRate',
    type: 'other',
    align: ALIGN,
    width: 60
  },
  {
    title: '激活1日LTV',
    key: 'oneDayLtv',
    type: 'other',
    align: ALIGN,
    width: 60
  },
  {
    title: '激活3日LTV',
    key: 'threeDayLtv',
    type: 'other',
    align: ALIGN,
    width: 60
  },
  {
    title: '激活7日LTV',
    key: 'sevenDayLtv',
    type: 'other',
    align: ALIGN,
    width: 60
  },
  {
    title: '激活30日LTV',
    key: 'thirtyDayLtv',
    type: 'other',
    align: ALIGN,
    width: 60
  },
  {
    title: '首日广告变现收入',
    key: 'monetizationAmount24h',
    type: 'other',
    align: ALIGN,
    width: 100
  },
  {
    title: '3日广告变现收入',
    key: 'monetizationAmount3d',
    type: 'other',
    align: ALIGN,
    width: 100
  },
  {
    title: '7日广告变现收入',
    key: 'monetizationAmount7d',
    type: 'other',
    align: ALIGN,
    width: 100
  },
  {
    title: '首日广告变现ROI',
    key: 'monetizationRoi24h',
    type: 'other',
    align: ALIGN,
    width: 100
  },
  {
    title: '3日广告变现ROI',
    key: 'monetizationRoi3d',
    type: 'other',
    align: ALIGN,
    width: 100
  },
  {
    title: '7日广告变现ROI',
    key: 'monetizationRoi7d',
    type: 'other',
    align: ALIGN,
    width: 100
  },
  {
    title: '广告变现人数',
    key: 'adMonetizationUserCount',
    type: 'other',
    align: ALIGN,
    width: 80
  },
  {
    title: '广告变现次数',
    key: 'adMonetizationCount',
    type: 'other',
    align: ALIGN,
    width: 80
  },
  {
    title: '广告变现人均次数',
    key: 'adMonetizationAvgCount',
    type: 'other',
    align: ALIGN,
    width: 90
  },
  {
    title: '创角次留',
    key: 'twoDayCreateRetain',
    type: 'other',
    align: ALIGN,
    width: 60
  },
  {
    title: '创角3留',
    key: 'threeDayCreateRetain',
    type: 'other',
    align: ALIGN,
    width: 60
  },
  {
    title: '创角4留',
    key: 'fourDayCreateRetain',
    type: 'other',
    align: ALIGN,
    width: 60
  },
  {
    title: '创角5留',
    key: 'fiveDayCreateRetain',
    type: 'other',
    align: ALIGN,
    width: 60
  },
  {
    title: '创角6留',
    key: 'sixDayCreateRetain',
    type: 'other',
    align: ALIGN,
    width: 60
  },
  {
    title: '创角7留',
    key: 'sevenDayCreateRetain',
    type: 'other',
    align: ALIGN,
    width: 60
  },
  {
    title: '创角10留',
    key: 'tenDayCreateRetain',
    type: 'other',
    align: ALIGN,
    width: 60
  },
  {
    title: '创角15留',
    key: 'fifteenDayCreateRetain',
    type: 'other',
    align: ALIGN,
    width: 60
  },
  {
    title: '创角30留',
    key: 'thirtyDayCreateRetain',
    type: 'other',
    align: ALIGN,
    width: 60
  },
  {
    title: '创角1日LTV',
    key: 'oneDayCreateLtv',
    type: 'other',
    align: ALIGN,
    width: 60
  },
  {
    title: '创角2日LTV',
    key: 'twoDayCreateLtv',
    type: 'other',
    align: ALIGN,
    width: 60
  },
  {
    title: '创角3日LTV',
    key: 'threeDayCreateLtv',
    type: 'other',
    align: ALIGN,
    width: 60
  },
  {
    title: '创角4日LTV',
    key: 'fourDayCreateLtv',
    type: 'other',
    align: ALIGN,
    width: 60
  },
  {
    title: '创角5日LTV',
    key: 'fiveDayCreateLtv',
    type: 'other',
    align: ALIGN,
    width: 60
  },
  {
    title: '创角6日LTV',
    key: 'sixDayCreateLtv',
    type: 'other',
    align: ALIGN,
    width: 60
  },
  {
    title: '创角7日LTV',
    key: 'sevenDayCreateLtv',
    type: 'other',
    align: ALIGN,
    width: 60
  },
  {
    title: '创角10日LTV',
    key: 'tenDayCreateLtv',
    type: 'other',
    align: ALIGN,
    width: 60
  },
  {
    title: '创角15日LTV',
    key: 'fifteenDayCreateLtv',
    type: 'other',
    align: ALIGN,
    width: 60
  },
  {
    title: '创角30日LTV',
    key: 'thirtyDayCreateLtv',
    type: 'other',
    align: ALIGN,
    width: 60
  },
  {
    title: '1日ROI',
    key: 'createRoleRoi1',
    type: 'other',
    align: ALIGN,
    width: 60
  },
  {
    title: '2日ROI',
    key: 'createRoleRoi2',
    type: 'other',
    align: ALIGN,
    width: 60
  },
  {
    title: '3日ROI',
    key: 'createRoleRoi3',
    type: 'other',
    align: ALIGN,
    width: 60
  },
  {
    title: '4日ROI',
    key: 'createRoleRoi4',
    type: 'other',
    align: ALIGN,
    width: 60
  },
  {
    title: '5日ROI',
    key: 'createRoleRoi5',
    type: 'other',
    align: ALIGN,
    width: 60
  },
  {
    title: '6日ROI',
    key: 'createRoleRoi6',
    type: 'other',
    align: ALIGN,
    width: 60
  },
  {
    title: '7日ROI',
    key: 'createRoleRoi7',
    type: 'other',
    align: ALIGN,
    width: 60
  },
  {
    title: '10日ROI',
    key: 'createRoleRoi10',
    type: 'other',
    align: ALIGN,
    width: 60
  },
  {
    title: '15日ROI',
    key: 'createRoleRoi15',
    type: 'other',
    align: ALIGN,
    width: 60
  },
  {
    title: '30日ROI',
    key: 'createRoleRoi30',
    type: 'other',
    align: ALIGN,
    width: 60
  }
]
